import React from 'react'

import { CircularProgress, styled } from '@mui/material'

import SetupConditions from './SetupConditions';
import FooterNavigation from './FooterNavigation'
import GroupConditionList from './GroupCondition/GroupConditionList'
import AddGroupCondition from './GroupCondition/AddGroupCondition'

import { useAppSelector } from '../hooks/reduxHooks';
import { transformGroupConditionToPayload } from '../util/groupConditionTransform';
import { useCustomFieldsLoading } from '../context/CustomField/customFieldHooks';
import EditFooterNavigation from './EditFooterNavigation';

const RootContainer = styled('div')(() => ({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    minHeight: '400px',
}))

const LoadingContainer = styled('div')(() => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    minHeight: '400px',
}))

export const CriteriaEngine = (props: any) => {
    const customFieldsLoading = useCustomFieldsLoading()

    const groupConditions = useAppSelector(({ groupConditions }) => groupConditions.groupConditions)

    const handleNextPage = (passedGroupConditions: any, wasSkipped: boolean = false, conditionStatementString: string = '') => {
        props.onNext(transformGroupConditionToPayload(passedGroupConditions), wasSkipped, conditionStatementString) 
    }

    const handleBackPage = () => {
        props.onBack(transformGroupConditionToPayload(groupConditions))
    }

    return (
        <>
            <RootContainer>
                { customFieldsLoading ? (
                    <LoadingContainer>
                        <CircularProgress size={34} />
                    </LoadingContainer>
                ): (
                    <>
                        <SetupConditions center={groupConditions.length === 0} />
                        <GroupConditionList  />
                        { groupConditions.length !== 0 && <AddGroupCondition /> }
                    </>
                ) }
            </RootContainer>
            {
                !props.isEditForm && (
                    <FooterNavigation 
                        fieldsLoading={customFieldsLoading}
                        offerService={props.offerService}
                        offerFormEId={props.offerFormEId}
                        onNext={handleNextPage}
                        onBack={handleBackPage}
                        onSkipStep={() => props.onNext(transformGroupConditionToPayload(groupConditions), true, '')}
                        onCancel={props.onCancelForm}
                    />
                )
            }
            {
                props.isEditForm && (
                    <EditFooterNavigation
                        fieldsLoading={customFieldsLoading}
                        offerService={props.offerService}
                        offerFormEId={props.offerFormEId}
                        onNext={() => props.onNext()}
                        onBack={handleBackPage}
                        onSkipStep={() => props.onNext(transformGroupConditionToPayload(groupConditions), true, '')}
                        onCancel={props.onCancelForm}
                    />
                )
            }
        </>
    )
}

export default CriteriaEngine